import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarRefreshLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Calendar refresh",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0249 16.6128C20.4391 16.6128 20.7748 16.9487 20.7749 17.3628C20.7749 17.777 20.4391 18.1128 20.0249 18.1128H3.98389C3.56967 18.1128 3.23389 17.777 3.23389 17.3628C3.23397 16.9487 3.56973 16.6128 3.98389 16.6128H20.0249Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8853 13.7456V11.2456C14.8853 10.8314 15.2211 10.4957 15.6353 10.4956C16.0495 10.4956 16.3853 10.8314 16.3853 11.2456V13.7456C16.3853 14.1598 16.0495 14.4956 15.6353 14.4956C15.2211 14.4955 14.8853 14.1598 14.8853 13.7456Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.61426 13.7456V11.2456C7.61426 10.8314 7.9501 10.4957 8.36426 10.4956C8.77847 10.4956 9.11426 10.8314 9.11426 11.2456V13.7456C9.11426 14.1598 8.77847 14.4956 8.36426 14.4956C7.9501 14.4955 7.61426 14.1598 7.61426 13.7456Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.1499 16.8447C3.14995 15.3367 3.6138 14.0763 4.53857 13.1973C5.45758 12.3238 6.73709 11.917 8.19385 11.917H15.814C17.2739 11.917 18.5536 12.3238 19.4712 13.1982C20.3942 14.0779 20.8539 15.3382 20.8501 16.8447V21.0381C20.8501 21.4523 20.5143 21.789 20.1001 21.7891C19.6862 21.7889 19.3503 21.453 19.3501 21.0391V16.8428C19.3535 15.6447 18.9955 14.8165 18.437 14.2842C17.8726 13.7462 17.0052 13.417 15.814 13.417H8.19385C7.0071 13.417 6.13874 13.7462 5.57178 14.2852C5.01085 14.8186 4.64995 15.6474 4.6499 16.8447V21.0381C4.64995 21.4522 4.31491 21.7888 3.90088 21.7891C3.48678 21.7891 3.15111 21.4531 3.15088 21.0391L3.1499 16.8447Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.36963 19.6501C8.78384 19.6501 9.11963 19.9859 9.11963 20.4001C9.11963 20.8144 8.78384 21.1501 8.36963 21.1501H8.35986C7.94565 21.1501 7.60986 20.8144 7.60986 20.4001C7.60986 19.9859 7.94565 19.6501 8.35986 19.6501H8.36963Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0049 19.6501C12.4191 19.6501 12.7549 19.9859 12.7549 20.4001C12.7549 20.8144 12.4191 21.1501 12.0049 21.1501H11.9951C11.5809 21.1501 11.2451 20.8144 11.2451 20.4001C11.2451 19.9859 11.5809 19.6501 11.9951 19.6501H12.0049Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6401 19.6501C16.0544 19.6501 16.3901 19.9859 16.3901 20.4001C16.3901 20.8144 16.0544 21.1501 15.6401 21.1501H15.6304C15.2162 21.1501 14.8804 20.8144 14.8804 20.4001C14.8804 19.9859 15.2162 19.6501 15.6304 19.6501H15.6401Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1621 2.43125C10.4549 2.13842 10.9297 2.13854 11.2227 2.43125C11.5155 2.72414 11.5155 3.1989 11.2227 3.49179C10.8604 3.85407 10.6001 4.11428 10.3105 4.4039C10.6001 4.69354 10.859 4.95338 11.2227 5.31699C11.5156 5.60987 11.5155 6.08463 11.2227 6.37754C10.9298 6.67033 10.455 6.67039 10.1621 6.37754C9.59995 5.81541 9.28164 5.4961 8.71973 4.93418C8.57917 4.79351 8.49996 4.60277 8.5 4.4039C8.50011 4.20504 8.57905 4.0142 8.71973 3.87363C9.28306 3.31074 9.59832 2.99503 10.1621 2.43125Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4766 6.32568C14.4765 5.67928 13.9521 5.15481 13.3057 5.15479H9.25C8.83579 5.15479 8.5 4.819 8.5 4.40479C8.5 3.99057 8.83579 3.65479 9.25 3.65479H13.3057C14.7805 3.65481 15.9765 4.85084 15.9766 6.32568C15.9766 7.80083 14.7806 8.99656 13.3057 8.99658H11.2031C10.789 8.99648 10.4531 8.66073 10.4531 8.24658C10.4534 7.83262 10.7891 7.49668 11.2031 7.49658H13.3057C13.952 7.49656 14.4766 6.97256 14.4766 6.32568Z",
			fill: "currentColor"
		})
	]
});
export default SvgCalendarRefreshLine;
